import { render } from "./PatientMedicalRecordTextSection.vue?vue&type=template&id=c172200a"
import script from "./PatientMedicalRecordTextSection.vue?vue&type=script&lang=js"
export * from "./PatientMedicalRecordTextSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__